function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "565rx2uc3a",
  d: "M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1.391c-3.644 0-6.609 2.965-6.609 6.609S8.356 18.609 12 18.609s6.609-2.965 6.609-6.609S15.644 5.391 12 5.391zm.07 8.744c.23 0 .452.092.615.254.162.161.254.386.254.615 0 .23-.092.452-.254.616-.162.162-.386.254-.615.254-.23 0-.454-.092-.616-.254-.162-.164-.254-.386-.254-.616 0-.23.092-.454.254-.615.162-.162.386-.254.616-.254zm0-5.335c.352 0 .643.262.689.601l.006.095v3.235c0 .384-.311.696-.695.696-.353 0-.644-.262-.69-.601l-.006-.095V9.496c0-.385.311-.696.696-.696z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16 -12) translate(16 12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "5ht614hewb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#565rx2uc3a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#565rx2uc3a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#5ht614hewb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z"
})))));

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c199a8ec.svg";
export { ForwardRef as ReactComponent };